(function($){

	var scrollAnim = function(){

		var win = $(window);

		var items = $('.scroll-animate-item');

		var itemScrollCheck = function(){

			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * 0.7) + winTop;

			// console.log(winTop);

			items.each(function(i, el){

				var item = $(el);
				var itemTop = item.offset().top;

				if(itemTop <= scrollTriggerPos){
					item.addClass('vis');
				}
				else{
					item.removeClass('vis');
				}

			});

		};

		itemScrollCheck();
		optimizedScroll.add(itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			// window.scrollTo(0,0);

			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 501;

				// if(!$('body').hasClass('scrolled')){
				// 	waitTime = 501;
					// $('body').addClass('scrolled');
				// }

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					$( 'body' ).removeClass( 'nav-open' );
					
					// setTimeout(function(){
						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;

						$("html, body").animate({scrollTop: finalPosition}, 1000);
					// }, 300);


				}, waitTime);
			}
		}

		$('.scroll-to-anchor a, a[href*="#"]').on('click', function(e){

			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				$( 'body' ).removeClass( 'nav-open' );
				
				var hashId = this.hash;
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 0;
					
					if(!$('body').hasClass('scrolled')){
						waitTime = 501;
						$('body').addClass('scrolled');
					}

					setTimeout(function(){
						// var anchorPosition = hashTarget.offset().top;
						var anchorPosition = $(hashId).offset().top;
						
						// console.log($('.site-header').outerHeight(), hashId, anchorPosition, $('#home-section-giftcards').offset().top);

						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						$("html, body").animate({scrollTop: finalPosition}, 1000);


					}, waitTime);
				}
			}
		});
	};


	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: false,
			dots: false,
			fade: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});
	};

	var homeHeroVideo = function() {
		// $('[data-action="play-hero-video"]').magnificPopup();

		$('[data-action="play-hero-embed"]').magnificPopup({
			type: 'iframe'
		});

		$('[data-action="play-hero-video"]').on('click', function(e) {
			e.preventDefault();
			// magnificPopup();
			$.magnificPopup.open({
				items: {
					src: '#hero-video-modal-container',
					type: 'inline'
				},
				callbacks: {
					open: function() {
						document.getElementById('hero-video-modal').play();
					},
					close: function() {
						document.getElementById('hero-video-modal').pause();
						document.getElementById('hero-video-modal').currentTime = 0;
					},
				}
			}, 0);
			
		});
	};

	var homeReviewsSlider = function() {
		$('.reviews-slider').slick({
			// autoplay: true,
			autoplaySpeed: 5000,
			speed: 1000,
			adaptiveHeight: true
		});
	};

	var menuFilter = function() {
		$('[data-action="menu-filter"]').on('click', function(e) {
			e.preventDefault();
			var target = $(this.hash);

			if(target.length){
				var title = $(this).html();
				var next = $(this).attr('data-next');
				var nextLink = $('#menu-next-link-'+next);

				$('.menu-cat').not(target).removeClass('vis');
				target.addClass('vis');

				$(this).parents('.filter-container').find('.filter-display').html(title);

				$('.menu-next-link').not(nextLink).removeClass('vis');
				nextLink.addClass('vis');

				// console.log(next, nextLink);
			}
			else{
				$('.menu-cat').addClass('vis');
				$(this).parents('.filter-container').find('.filter-display').html('All');
				$('.menu-next-link').removeClass('vis');
			}
			// console.log(target);
		});
	};

	var videoSize = function (videoContainerSelector, vidInnerSelector, vidElID) {
		var videoContainer = $(videoContainerSelector);
		
		if( videoContainer.length > 0){

			var videoContainerRatio = videoContainer.outerHeight() / videoContainer.outerWidth();
			var vidObj = videoContainer.find(vidInnerSelector);
			var vidEl = document.getElementById(vidElID);
			var vidRatio = vidEl.videoHeight / vidEl.videoWidth;

			if (isNaN(vidRatio) || vidRatio == 0) {
				vidRatio = 0.5625;
			}

			var videoResize = function () {
				videoContainerRatio = videoContainer.outerHeight() / videoContainer.outerWidth();

				vidRatio = vidEl.videoHeight / vidEl.videoWidth;

				if (isNaN(vidRatio) || vidRatio == 0) {
					vidRatio = 0.5625;
				}

				if (videoContainerRatio <= vidRatio) {
					vidObj.removeClass("tall");
					vidObj.addClass("wide");
				} else {
					vidObj.removeClass("wide");
					vidObj.addClass("tall");
				}
			};

			videoResize();
			optimizedResize.add(videoResize);
		}
	};

	var specialsEvents = function() {
		$('.specials-events-list').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery:{
				enabled: true,
				preload: [1,1],
			}
		});
	};



	$(document).ready(function(){
		scrollAnim();
		scrollToAnchor();
		homeHeroSlider();
		homeHeroVideo();
		homeReviewsSlider();
		menuFilter();
		specialsEvents();
		videoSize('.banner-video-container', '.banner-video-inner', 'banner-video');
		videoSize('.footer-video-container', '.footer-video-inner', 'footer-video');

        $('.hero-video-container').addClass('vis');
	});

    // window.addEventListener('load', function() {
    //     var videoContainer = $('.hero-video-container');
        // videoContainer.addClass('vis');
    // }, false);

})(jQuery);